import Swal from 'sweetalert2';

export function useAlert() {
  /**
   * نمایش پیام موفقیت
   */
  const showSuccess = (message, title = 'موفق!') => {
    return Swal.fire({
      icon: 'success',
      title: title,
      text: message,
      confirmButtonText: 'باشه',
      confirmButtonColor: '#10b981',
      timer: 3000,
      timerProgressBar: true
    });
  };

  /**
   * نمایش پیام خطا
   */
  const showError = (message, title = 'خطا!') => {
    return Swal.fire({
      icon: 'error',
      title: title,
      text: message,
      confirmButtonText: 'باشه',
      confirmButtonColor: '#ef4444'
    });
  };

  /**
   * نمایش پیام هشدار
   */
  const showWarning = (message, title = 'توجه!') => {
    return Swal.fire({
      icon: 'warning',
      title: title,
      text: message,
      confirmButtonText: 'باشه',
      confirmButtonColor: '#5186dd'
    });
  };

  /**
   * نمایش پیام اطلاعات
   */
  const showInfo = (message, title = 'اطلاعات') => {
    return Swal.fire({
      icon: 'info',
      title: title,
      text: message,
      confirmButtonText: 'باشه',
      confirmButtonColor: '#5186dd'
    });
  };

  /**
   * درخواست تأیید از کاربر
   */
  const showConfirm = (message, title = 'آیا مطمئن هستید؟', options = {}) => {
    return Swal.fire({
      icon: 'question',
      title: title,
      text: message,
      showCancelButton: true,
      confirmButtonText: options.confirmText || 'بله، مطمئنم',
      cancelButtonText: options.cancelText || 'انصراف',
      confirmButtonColor: options.confirmColor || '#10b981',
      cancelButtonColor: options.cancelColor || '#6b7280',
      reverseButtons: true,
      ...options
    });
  };

  /**
   * نمایش لودینگ
   */
  const showLoading = (message = 'در حال پردازش...', title = 'لطفاً صبر کنید') => {
    return Swal.fire({
      title: title,
      text: message,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  };

  /**
   * بستن لودینگ
   */
  const closeLoading = () => {
    Swal.close();
  };

  /**
   * تأیید حذف
   */
  const confirmDelete = (itemName = 'این مورد') => {
    return Swal.fire({
      icon: 'warning',
      title: 'حذف شود؟',
      text: `آیا از حذف ${itemName} اطمینان دارید؟ این عمل قابل بازگشت نیست!`,
      showCancelButton: true,
      confirmButtonText: 'بله، حذف شود',
      cancelButtonText: 'انصراف',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      reverseButtons: true
    });
  };

  /**
   * نمایش Toast (پیام کوچک در گوشه صفحه)
   */
  const showToast = (message, type = 'success', position = 'top-end') => {
    const Toast = Swal.mixin({
      toast: true,
      position: position,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });

    return Toast.fire({
      icon: type,
      title: message
    });
  };

  /**
   * نمایش پیام با HTML
   */
  const showHtml = (htmlContent, title = '', options = {}) => {
    return Swal.fire({
      title: title,
      html: htmlContent,
      confirmButtonText: 'باشه',
      confirmButtonColor: '#5186dd',
      ...options
    });
  };

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm,
    showLoading,
    closeLoading,
    confirmDelete,
    showToast,
    showHtml
  };
}

